"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _colors = require("../colors.config");
var _default = function _default(isFontBigger, isHighContrast) {
  return {
    tooltip: {
      '&.MuiTooltip-tooltipPlacementLeft': {
        '&:after, &:before': {
          bottom: '50%',
          left: '100%',
          transform: 'rotate(90deg) translateX(50%)'
        }
      },
      '&.MuiTooltip-tooltipPlacementRight': {
        '&:after, &:before': {
          bottom: '50%',
          right: '100%',
          transform: 'rotate(-90deg) translateX(-50%)'
        }
      },
      '&.MuiTooltip-tooltipPlacementTop': {
        '&:after, &:before': {
          left: '50%',
          top: '100%',
          transform: 'rotate(180deg) translateX(50%)'
        }
      },
      '&:after': {
        'border-bottom-color': _colors.Black[10],
        'border-color': 'rgba(136, 183, 213, 0)',
        'border-width': '6px'

        // 'margin-left': '0px'
      },

      '&:after, &:before': {
        border: 'solid transparent',
        bottom: '100%',
        content: '" "',
        height: '0',
        left: '50%',
        'pointer-events': 'none',
        position: 'absolute',
        transform: 'translateX(-50%)',
        'transform-origin': 'center',
        width: '0'
      },
      '&:before': {
        'border-bottom-color': _colors.Black[100],
        'border-color': 'rgba(194, 225, 245, 0)',
        'border-width': '7px'
      },
      backgroundColor: isHighContrast ? _colors.Black[900] : _colors.Black[10],
      border: "1px solid ".concat(_colors.Black[100]),
      borderRadius: '8px',
      boxShadow: '0px 2px 3px #00000007',
      color: isHighContrast ? '#fff' : _colors.Black[300],
      fontSize: isFontBigger ? '17px' : '12px',
      padding: '8px 10px',
      position: 'relative'
    }
  };
};
exports.default = _default;